import { BreadcrumbSlot, useBreadcrumb } from "@redotech/arbiter/breadcrumb";
import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";
import { Outlet } from "react-router-dom";

export const ClaimsListBreadcrumbLayout = memo(
  function ClaimsListBreadcrumbLayout({
    breadcrumb,
  }: {
    breadcrumb: BreadcrumbSlot;
  }) {
    const { t } = useTranslation();
    useBreadcrumb(breadcrumb, t("Claims"));
    return <Outlet />;
  },
);

export const CarrierClaimsListBreadcrumbLayout = memo(
  function CarrierClaimsListBreadcrumbLayout({
    breadcrumb,
  }: {
    breadcrumb: BreadcrumbSlot;
  }) {
    const { t } = useTranslation();
    useBreadcrumb(breadcrumb, t("Carrier claims"));
    return <Outlet />;
  },
);
